//Library Imports
import React, { useState } from 'react';
import styled from 'styled-components';

//Local Imports
import CampaignList from '../CreateAutomation/CampaignList';
import EmailList from '../CreateAutomation/EmailList';

interface ISelectEmailProps {
  selectedEmailId: number;
  setSelectedEmail: (id: number) => void;
}

const SelectEmail: React.FC<ISelectEmailProps> = (props) => {
  // Props
  const { selectedEmailId, setSelectedEmail } = props;

  // Local States
  const [isFiltered, setIsFiltered] = useState<boolean>(false);

  return (
    <Wrapper>
      <div className="select-trigger-wrapper">
        <div className="d-flex align-items-start trigger-main">
          <div className="trigger-sidebar">
            <CampaignList setIsFiltered={setIsFiltered} />
          </div>
          <EmailList
            isFiltered={isFiltered}
            selectedEmailId={selectedEmailId}
            changeHandler={(id: number) => {
              setSelectedEmail(id);
            }}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default SelectEmail;

const Wrapper = styled.div`
  width: calc(100% - 200px);
  .email-name {
    font-size: 26px !important;
    @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 22px !important;
    }
  }
  .trigger-sidebar {
    /* min-height: 100vh; */
  }
  .select-trigger-wrapper {
    width: 100%;
    height: 100%;
    .hide-btn {
      opacity: 0;
      pointer-events: none;
    }
    .trigger-main {
      width: 100%;
      height: 100%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 100%;
        /* max-height: calc(100vh - 225px); */
        overflow: hidden;
      }
    }
  }
`;
